import type { ModuleManifest } from "./types";

// evDataBreaches (tabid: 96) — GDPR Art. 33 data breaches + NIS2 Art. 23 security incidents
export const incidentsManifest: ModuleManifest = {
  name: "incidents",
  label: "Violazione / Incidente",
  labelPlural: "Violazioni e Incidenti",
  coreBOSModule: "evDataBreaches",
  wsidPrefix: "96x",
  type: "standard",
  routes: {
    list: "/incidents",
    show: "/incidents/show/:id",
    create: "/incidents/create",
    edit: "/incidents/edit/:id",
  },
  navigation: {
    icon: "AlertOutlined",
    order: 14,
    group: "Security",
  },
  routing: {
    keywords: ["incident", "incidents", "breach", "incidente", "violazione", "data breach", "databreach"],
    searchFields: ["dbrtitle"],
    defaultSort: { field: "dbrdatetime", order: "desc" },
  },
  context: { supported: true, entityKey: "incidents" },
  fields: [
    { name: "dbrtitle", label: "Titolo", type: "string", required: true },
    { name: "dbrdatetime", label: "Data Rilevamento", type: "datetime" },
    { name: "dbreactualdate", label: "Data Effettiva", type: "datetime" },
    { name: "dbrmodality", label: "Modalità", type: "picklist" },
    { name: "dbrstatus", label: "Stato", type: "picklist" },
    { name: "dbrpriority", label: "Priorità", type: "picklist" },
    { name: "bdrsource", label: "Fonte", type: "string" },
    { name: "dbrcategory", label: "Categoria", type: "picklist" },
    { name: "dbrlinktocontact", label: "Contatto", type: "reference" },
    { name: "dbrnotify", label: "Notifica", type: "text" },
    { name: "dbrnotificationdate", label: "Data Notifica", type: "date" },
    { name: "dbrprotocolnumber", label: "Numero Protocollo", type: "string" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Contacts", field: "dbrlinktocontact", label: "Contatto", icon: "UserOutlined", displayField: "firstname" },
  ],
  requiredFields: ["dbrtitle"],
  viewStrategy: "generic",
};
